import * as React from 'react';
import { ReactNode } from 'react';

import styled from 'styled-components';

import { MenuItems } from 'types';
import { ExitButton, UserInfo } from 'atoms';
import { MenuItemList, LanguageSwitcher } from 'molecules';

import { Colors } from 'services/ColorService';

export interface IMenuComponent {
  activeMenu?: MenuItems;
  menuItems: ReactNode[];
  onExit: () => void;
  userFirstName?: string | null;
  userLastName?: string | null;
  userEmail?: string | null;
}

export const MenuComponent = ({
  menuItems,
  onExit,
  userFirstName,
  userLastName,
  userEmail,
}: IMenuComponent) => (
  <Wrapper>
    <Container>
      <MenuItemList>{menuItems}</MenuItemList>
      <RightGroup>
        <LanguageSwitcher />
        <UserInfo
          firstName={userFirstName}
          lastName={userLastName}
          email={userEmail}
        />
        <ExitButton onClick={onExit} />
      </RightGroup>
    </Container>
  </Wrapper>
);

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${Colors.White};
  padding: 21px 2px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: inherit;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
